let urlToPreload,mouseoverTimer,lastTouchTimestamp;const prefetcher=document.createElement("link"),isSupported=prefetcher.relList&&prefetcher.relList.supports&&prefetcher.relList.supports("prefetch"),isDataSaverEnabled=navigator.connection&&navigator.connection.saveData,allowQueryString="instantAllowQueryString"in document.body.dataset,allowExternalLinks="instantAllowExternalLinks"in document.body.dataset;if(isSupported&&!isDataSaverEnabled){prefetcher.rel="prefetch",document.head.appendChild(prefetcher);const e={capture:!0,passive:!0};document.addEventListener("touchstart",touchstartListener,e),document.addEventListener("mouseover",mouseoverListener,e)}function touchstartListener(e){lastTouchTimestamp=performance.now();const t=e.target.closest("a");isPreloadable(t)&&(t.addEventListener("touchcancel",touchendAndTouchcancelListener,{passive:!0}),t.addEventListener("touchend",touchendAndTouchcancelListener,{passive:!0}),urlToPreload=t.href,preload(t.href))}function touchendAndTouchcancelListener(){urlToPreload=void 0,stopPreloading()}function mouseoverListener(e){if(performance.now()-lastTouchTimestamp<1100)return;const t=e.target.closest("a");isPreloadable(t)&&(t.addEventListener("mouseout",mouseoutListener,{passive:!0}),urlToPreload=t.href,mouseoverTimer=setTimeout(()=>{preload(t.href),mouseoverTimer=void 0},65))}function mouseoutListener(e){e.relatedTarget&&e.target.closest("a")==e.relatedTarget.closest("a")||(mouseoverTimer?(clearTimeout(mouseoverTimer),mouseoverTimer=void 0):(urlToPreload=void 0,stopPreloading()))}function isPreloadable(e){if(!e||!e.href)return;if(urlToPreload==e.href)return;const t=new URL(e.href);return!(!(allowExternalLinks||t.origin==location.origin||"instant"in e.dataset)||!["http:","https:"].includes(t.protocol)||"http:"==t.protocol&&"https:"==location.protocol||!(allowQueryString||!t.search||"instant"in e.dataset)||t.hash&&t.pathname+t.search==location.pathname+location.search||"noInstant"in e.dataset)||void 0}function preload(e){prefetcher.href=e}function stopPreloading(){prefetcher.removeAttribute("href")}
;(()=>{
  const marker='coffeifymugBlogImageFallback';
  if (window[marker]) return;
  window[marker]=true;
  const fallback='https://cdn.shopify.com/s/files/1/0830/9394/6666/products/landscape-tall-coffee-tea-mug-817505.jpg?v=1702045929';
  const brokenPatterns=['landscape-coffee-tea-mug-392721_3361a445'];
  const shouldFix=(img)=>img&&img.tagName==='IMG'&&img.classList&&img.classList.contains('blog-post-card__image')&&(brokenPatterns.some((p)=>(img.currentSrc||img.src||'').includes(p)||(img.getAttribute('src')||'').includes(p))||(img.complete&&img.naturalWidth===0));
  const fix=(img)=>{
    if(!shouldFix(img)||img.dataset.coffeifyFallbackApplied==='1') return;
    img.dataset.coffeifyFallbackApplied='1';
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src=fallback;
  };
  document.addEventListener('error',(event)=>{ if(event.target&&event.target.tagName==='IMG') fix(event.target); },true);
  const scan=()=>document.querySelectorAll('img.blog-post-card__image').forEach(fix);
  document.addEventListener('DOMContentLoaded',scan);
  window.addEventListener('load',scan);
  setTimeout(scan,1500);
  setTimeout(scan,5000);
})();
;(()=>{
  const marker='photo_picker_buyer_route_live_cleanup_20260606_mutation';
  const bridgeMarker='photo_picker_buyer_route_bridge_20260609_v2';
  const shopShareRoute='/pages/coffeifymug-shop-share-fast?utm_source=photo_picker_page&amp;utm_medium=asset_bridge&amp;utm_campaign=photo_picker_20260609';
  const assetPacketRoute='/pages/coffeifymug-editor-buyer-asset-packet?utm_source=photo_picker_page&amp;utm_medium=asset_bridge&amp;utm_campaign=photo_picker_20260609';
  const legacyBuyerRouteHints=['/pages/coffeifymug-product-media-kit','/pages/museum-shop-mug-sample-set'];
  if(window[marker]) return;
  window[marker]=true;
  if(window.location.pathname!=='/pages/coffee-mug-photo-picker') return;

  function rewriteLegacyAnchors(root){
    if(!root) return;
    root.querySelectorAll('a[href]').forEach((link)=>{
      const rawHref=link.getAttribute('href') || '';
      const href=rawHref.replace(/&amp;/g,'&');
      if(!legacyBuyerRouteHints.some((hint)=>href.indexOf(hint)!==-1)) return;
      link.setAttribute('href', shopShareRoute);
      const text=(link.textContent || '').trim();
      if(!text || /product media kit|museum shop mug sample set|buyer sample set/i.test(text)){
        link.textContent='open Shop or Share Fast';
      }
      link.setAttribute('data-growth-bridge', bridgeMarker);
    });
  }

  const bridgeHtml=[
    '<div style="margin:0 auto 18px;max-width:1080px;padding:12px 14px;border:1px solid #d8c29d;background:#f7faf8;border-radius:10px;line-height:1.45;box-shadow:0 8px 22px rgba(29,43,36,0.04);">',
    '<p style="margin:0 0 8px;"><strong>Buyer or review route:</strong> <a href="'+shopShareRoute+'">open Shop or Share Fast</a> if this visit is for a museum shop, gift guide, or editorial handoff.</p>',
    '<p style="margin:0;"><strong>Editor support:</strong> <a href="'+assetPacketRoute+'">open the Editor &amp; Buyer Asset Packet</a> if you need quick specs, images, and a single forwardable route.</p>',
    '</div>'
  ].join('');

  function install(){
    const main=document.getElementById('main');
    if(!main) return;
    rewriteLegacyAnchors(main);
    const existing=document.getElementById('coffeifymug-photo-picker-buyer-route-bridge');
    if(existing){
      existing.setAttribute('data-growth-bridge', bridgeMarker);
      existing.innerHTML=bridgeHtml;
      return;
    }
    const bridge=document.createElement('section');
    bridge.id='coffeifymug-photo-picker-buyer-route-bridge';
    bridge.setAttribute('data-growth-bridge', bridgeMarker);
    bridge.innerHTML=bridgeHtml;
    main.insertBefore(bridge, main.firstChild);
  }

  function observe(){
    if(window.__coffeifymugPhotoPickerBuyerRouteObserver) return;
    const root=document.getElementById('main') || document.body;
    if(!root || !window.MutationObserver) return;
    const observer=new MutationObserver(()=>install());
    observer.observe(root,{childList:true,subtree:true});
    window.__coffeifymugPhotoPickerBuyerRouteObserver=observer;
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', ()=>{install();observe();}, {once:true});
  }else{
    install();
    observe();
  }
  window.addEventListener('load', ()=>{install();observe();}, {once:true});
  setTimeout(install, 250);
  setTimeout(install, 1500);
  setTimeout(install, 4000);
  setTimeout(install, 8000);
})();
;(()=>{
  const marker='round_product_fast_route_bridge_20260606_mutation';
  const bridgeMarker='round_product_fast_route_bridge_20260606_v1';
  if(window[marker]) return;
  window[marker]=true;
  if(window.location.pathname!=='/products/round-coffee-tea-mug') return;

  const bridgeHtml=[
    '<div style="margin:0 0 14px;padding:12px 14px;border:1px solid #d8e4df;border-radius:8px;background:#f7fbf9;line-height:1.45;">',
    '<p style="margin:0 0 8px;"><strong>Fast route check:</strong> stay on this page if you want the safest everyday mug for coffee, tea, gifting, or desk use. If that is already the fit, use the Add to cart button just below.</p>',
    '<div style="display:grid;gap:8px;margin:0 0 8px;">',
    '<a style="display:block;padding:9px 12px;border-radius:8px;border:1px solid #c7d9d2;color:#1f6b57;text-decoration:none;font-weight:600;text-align:center;background:#ffffff;" href="/products/landscape-tall-coffee-tea-mug?utm_source=round_product&amp;utm_medium=fast_bridge&amp;utm_campaign=round_product_20260606">Want more height? Compare the Tall Mug</a>',
    '<a style="display:block;padding:9px 12px;border-radius:8px;border:1px solid #c7d9d2;color:#1f6b57;text-decoration:none;font-weight:600;text-align:center;background:#ffffff;" href="/products/pleated-coffee-tea-cup?utm_source=round_product&amp;utm_medium=fast_bridge&amp;utm_campaign=round_product_20260606">Want the lower-price route? Open the Pleated Cup</a>',
    '<a style="display:block;padding:9px 12px;border-radius:8px;background:#1f6b57;color:#ffffff;text-decoration:none;font-weight:600;text-align:center;" href="/pages/pick-a-mug-fast?utm_source=round_product&amp;utm_medium=fast_bridge&amp;utm_campaign=round_product_20260606">Still comparing? Open Pick a Mug Fast</a>',
    '</div>',
    '<p style="margin:0;font-size:13px;color:#4b4f4c;"><strong>Buyer or review route:</strong> <a href="/pages/museum-shop-mug-sample-set?utm_source=round_product&amp;utm_medium=fast_bridge&amp;utm_campaign=round_product_20260606">Buyer Sample Set</a> if this visit is really for store review or sampling.</p>',
    '</div>'
  ].join('');

  function install(){
    const buyBlock=document.querySelector('.product-info__block-item[data-block-type="buy-buttons"]');
    if(!buyBlock || !buyBlock.parentElement) return;
    const existing=document.getElementById('coffeifymug-round-product-fast-bridge');
    if(existing){
      existing.setAttribute('data-growth-bridge', bridgeMarker);
      existing.innerHTML=bridgeHtml;
      return;
    }
    const bridge=document.createElement('div');
    bridge.id='coffeifymug-round-product-fast-bridge';
    bridge.className='product-info__block-item';
    bridge.setAttribute('data-growth-bridge', bridgeMarker);
    bridge.innerHTML=bridgeHtml;
    buyBlock.parentElement.insertBefore(bridge, buyBlock);
  }

  function observe(){
    if(window.__coffeifymugRoundProductFastBridgeObserver) return;
    const root=document.querySelector('.product-info__block-list') || document.body;
    if(!root || !window.MutationObserver) return;
    const observer=new MutationObserver(()=>install());
    observer.observe(root,{childList:true,subtree:true});
    window.__coffeifymugRoundProductFastBridgeObserver=observer;
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', ()=>{install();observe();}, {once:true});
  }else{
    install();
    observe();
  }
  window.addEventListener('load', ()=>{install();observe();}, {once:true});
  setTimeout(install, 250);
  setTimeout(install, 1500);
  setTimeout(install, 4000);
  setTimeout(install, 8000);
})();
;(()=>{
  const marker='media_kit_visual_strip_bridge_20260606_mutation';
  const bridgeMarker='media_kit_visual_strip_bridge_20260606_v1';
  if(window[marker]) return;
  window[marker]=true;
  if(window.location.pathname!=='/pages/coffeifymug-product-media-kit') return;

  const bridgeHtml=[
    '<div style="margin:0 auto 18px;max-width:1120px;padding:16px;border:1px solid #d8c29d;border-radius:12px;background:#fffdf8;line-height:1.45;box-shadow:0 8px 22px rgba(29,43,36,0.06);">',
    '<p style="margin:0 0 10px;"><strong>Fast visual route:</strong> if this visit is really about choosing or forwarding one product fast, use the real-product cards below instead of reading the full media kit first.</p>',
    '<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(220px,1fr));gap:14px;margin:0 0 12px;">',
    '<article style="border:1px solid #eadbc2;border-radius:10px;background:#ffffff;overflow:hidden;">',
    '<a href="/products/round-coffee-tea-mug?variant=47076797415722&amp;utm_source=product_media_kit&amp;utm_medium=dom_bridge&amp;utm_campaign=media_kit_visual_20260606" style="display:block;background:#f7f2ea;"><img src="https://cdn.shopify.com/s/files/1/0830/9394/6666/files/02-round-coffee-tea-mug_423bac90-afed-4563-8f7e-13306c6c1a27.png?v=1780507188" alt="Round Ceramic Coffee Mug from CoffeifyMug" loading="eager" style="display:block;width:100%;height:220px;object-fit:cover;"></a>',
    '<div style="padding:14px;">',
    '<p style="margin:0 0 6px;font-size:12px;letter-spacing:0.06em;text-transform:uppercase;color:#7b6546;">Safest first pick</p>',
    '<h3 style="margin:0 0 6px;font-size:20px;line-height:1.2;color:#1d2b24;">Round Mug</h3>',
    '<p style="margin:0 0 12px;color:#4b4f4c;">Best everyday route for direct shopping, gifting, and low-friction first reviews.</p>',
    '<a href="/products/round-coffee-tea-mug?variant=47076797415722&amp;utm_source=product_media_kit&amp;utm_medium=dom_bridge&amp;utm_campaign=media_kit_visual_20260606" style="display:block;padding:10px 12px;border-radius:8px;background:#1f6b57;color:#ffffff;text-decoration:none;font-weight:700;text-align:center;">View Round Mug</a>',
    '</div>',
    '</article>',
    '<article style="border:1px solid #eadbc2;border-radius:10px;background:#ffffff;overflow:hidden;">',
    '<a href="/products/landscape-tall-coffee-tea-mug?variant=47076796236074&amp;utm_source=product_media_kit&amp;utm_medium=dom_bridge&amp;utm_campaign=media_kit_visual_20260606" style="display:block;background:#f7f2ea;"><img src="https://cdn.shopify.com/s/files/1/0830/9394/6666/files/01-landscape-tall-coffee-tea-mug_4efa4290-b720-45d6-b5cb-f6e0c3bbbe90.png?v=1780507180" alt="Landscape Tall Coffee and Tea Mug from CoffeifyMug" loading="lazy" style="display:block;width:100%;height:220px;object-fit:cover;"></a>',
    '<div style="padding:14px;">',
    '<p style="margin:0 0 6px;font-size:12px;letter-spacing:0.06em;text-transform:uppercase;color:#7b6546;">Shelf-led option</p>',
    '<h3 style="margin:0 0 6px;font-size:20px;line-height:1.2;color:#1d2b24;">Landscape Tall</h3>',
    '<p style="margin:0 0 12px;color:#4b4f4c;">Stronger display silhouette for desks, shelves, and more visual coffee corners.</p>',
    '<a href="/products/landscape-tall-coffee-tea-mug?variant=47076796236074&amp;utm_source=product_media_kit&amp;utm_medium=dom_bridge&amp;utm_campaign=media_kit_visual_20260606" style="display:block;padding:10px 12px;border-radius:8px;background:#1f6b57;color:#ffffff;text-decoration:none;font-weight:700;text-align:center;">View Landscape Tall</a>',
    '</div>',
    '</article>',
    '<article style="border:1px solid #eadbc2;border-radius:10px;background:#ffffff;overflow:hidden;">',
    '<a href="/products/pleated-coffee-tea-cup?variant=47076746690858&amp;utm_source=product_media_kit&amp;utm_medium=dom_bridge&amp;utm_campaign=media_kit_visual_20260606" style="display:block;background:#f7f2ea;"><img src="https://cdn.shopify.com/s/files/1/0830/9394/6666/files/03-pleated-coffee-tea-cup_79c669b4-fd80-44af-a00b-345aebd96289.png?v=1780507196" alt="Pleated Elegant Ceramic Coffee Cup from CoffeifyMug" loading="lazy" style="display:block;width:100%;height:220px;object-fit:cover;"></a>',
    '<div style="padding:14px;">',
    '<p style="margin:0 0 6px;font-size:12px;letter-spacing:0.06em;text-transform:uppercase;color:#7b6546;">Lower-price entry</p>',
    '<h3 style="margin:0 0 6px;font-size:20px;line-height:1.2;color:#1d2b24;">Pleated Cup</h3>',
    '<p style="margin:0 0 12px;color:#4b4f4c;">Fastest lighter-commitment route for tea breaks, gifting, and smaller pours.</p>',
    '<a href="/products/pleated-coffee-tea-cup?variant=47076746690858&amp;utm_source=product_media_kit&amp;utm_medium=dom_bridge&amp;utm_campaign=media_kit_visual_20260606" style="display:block;padding:10px 12px;border-radius:8px;background:#1f6b57;color:#ffffff;text-decoration:none;font-weight:700;text-align:center;">View Pleated Cup</a>',
    '</div>',
    '</article>',
    '</div>',
    '<p style="margin:0;"><strong>Still need a cleaner support route?</strong> <a href="/pages/pick-a-mug-fast?utm_source=product_media_kit&amp;utm_medium=dom_bridge&amp;utm_campaign=media_kit_visual_20260606">Open Pick a Mug Fast</a>, <a href="/pages/coffee-mug-photo-picker?utm_source=product_media_kit&amp;utm_medium=dom_bridge&amp;utm_campaign=media_kit_visual_20260609">Open the Photo Picker</a>, or <a href="/pages/coffeifymug-editor-buyer-asset-packet?utm_source=product_media_kit&amp;utm_medium=dom_bridge&amp;utm_campaign=media_kit_visual_20260609">Editor &amp; Buyer Asset Packet</a>.</p>',
    '</div>'
  ].join('');

  function install(){
    const main=document.getElementById('main');
    if(!main) return;
    const existing=document.getElementById('coffeifymug-media-kit-visual-strip');
    if(existing){
      existing.setAttribute('data-growth-bridge', bridgeMarker);
      existing.innerHTML=bridgeHtml;
      return;
    }
    const bridge=document.createElement('section');
    bridge.id='coffeifymug-media-kit-visual-strip';
    bridge.setAttribute('data-growth-bridge', bridgeMarker);
    bridge.innerHTML=bridgeHtml;
    main.insertBefore(bridge, main.firstChild);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', install, {once:true});
  }else{
    install();
  }
  window.addEventListener('load', install, {once:true});
  setTimeout(install, 250);
  setTimeout(install, 1500);
  setTimeout(install, 4000);
})();
;(()=>{
  const marker='unique_collection_live_bridge_20260606_mutation';
  const bridgeMarker='unique_collection_live_bridge_20260606_v1';
  if(window[marker]) return;
  window[marker]=true;
  if(window.location.pathname!=='/collections/unique-coffee-mugs') return;

  const bridgeHtml=[
    '<div style="margin:0 auto 18px;max-width:1120px;padding:14px 16px;border:1px solid #d8c29d;background:#fffdf8;border-radius:10px;line-height:1.45;box-shadow:0 8px 22px rgba(29,43,36,0.06);">',
    '<div style="display:flex;flex-wrap:wrap;gap:10px;align-items:flex-start;justify-content:space-between;margin:0 0 12px;">',
    '<div style="max-width:680px;">',
    '<p style="margin:0 0 6px;font-size:12px;letter-spacing:0.08em;text-transform:uppercase;color:#7b6546;">Current unique-mug shortlist</p>',
    '<h2 style="margin:0 0 8px;font-size:26px;line-height:1.15;color:#1d2b24;">Start with three clearer unique-mug routes instead of browsing the whole grid first.</h2>',
    '<p style="margin:0;color:#4b4f4c;">If you landed here for a more distinctive ceramic mug, use the live product shortcuts below to choose by mood and size before the collection scroll turns into over-comparing.</p>',
    '</div>',
    '<div style="display:flex;flex-wrap:wrap;gap:8px;align-items:center;">',
    '<a style="display:inline-block;padding:8px 10px;border:1px solid #1f6b57;border-radius:999px;text-decoration:none;color:#ffffff;font-weight:600;background:#1f6b57;" href="/pages/pick-a-mug-fast?utm_source=unique_collection&amp;utm_medium=live_bridge&amp;utm_campaign=unique_collection_bridge_20260606">Pick a Mug Fast</a>',
    '<a style="display:inline-block;padding:8px 10px;border:1px solid #1f6b57;border-radius:999px;text-decoration:none;color:#1f6b57;font-weight:600;background:#ffffff;" href="/pages/coffeifymug-product-media-kit?utm_source=unique_collection&amp;utm_medium=live_bridge&amp;utm_campaign=unique_collection_bridge_20260606">Product Shop or Share Fast</a>',
    '<a style="display:inline-block;padding:8px 10px;border:1px solid #d8c29d;border-radius:999px;text-decoration:none;color:#7b6546;font-weight:600;background:#fff7e8;" href="/pages/museum-shop-mug-sample-set?utm_source=unique_collection&amp;utm_medium=live_bridge&amp;utm_campaign=unique_collection_bridge_20260606">Buyer Sample Set</a>',
    '</div>',
    '</div>',
    '<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(200px,1fr));gap:12px;">',
    '<article style="display:flex;flex-direction:column;overflow:hidden;border:1px solid #eadbc2;border-radius:10px;background:#ffffff;">',
    '<a href="/products/the-rock-coffee-tea-mug?utm_source=unique_collection&amp;utm_medium=live_bridge&amp;utm_campaign=unique_collection_bridge_20260606" style="display:block;background:#f7f2ea;"><img src="https://cdn.shopify.com/s/files/1/0830/9394/6666/products/the-rock-coffee-tea-mug-779151.jpg?v=1702045920" alt="Big Coffee Mug The Rock from CoffeifyMug" loading="eager" style="display:block;width:100%;height:220px;object-fit:cover;"></a>',
    '<div style="display:flex;flex:1;flex-direction:column;padding:12px;">',
    '<p style="margin:0 0 6px;font-size:12px;letter-spacing:0.06em;text-transform:uppercase;color:#7b6546;">Bolder daily-use pick</p>',
    '<h3 style="margin:0 0 6px;font-size:18px;line-height:1.2;color:#1d2b24;">The Rock Mug</h3>',
    '<p style="margin:0 0 10px;color:#4b4f4c;font-size:14px;">Best if you want a more substantial unique mug with a larger feel and stronger desk presence right away.</p>',
    '<div style="margin-top:auto;display:grid;gap:8px;">',
    '<a style="display:block;padding:10px 12px;border-radius:8px;background:#1f6b57;color:#ffffff;text-decoration:none;font-weight:600;text-align:center;" href="/products/the-rock-coffee-tea-mug?variant=47076791746858&amp;utm_source=unique_collection&amp;utm_medium=live_bridge&amp;utm_campaign=unique_collection_bridge_20260606">View The Rock Mug</a>',
    '<a style="display:block;padding:9px 12px;border-radius:8px;border:1px solid #c7d9d2;color:#1f6b57;text-decoration:none;font-weight:600;text-align:center;background:#f8fcfa;" href="/products/the-rock-coffee-tea-mug?utm_source=unique_collection&amp;utm_medium=live_bridge&amp;utm_campaign=unique_collection_bridge_20260606">Open product</a>',
    '</div>',
    '</div>',
    '</article>',
    '<article style="display:flex;flex-direction:column;overflow:hidden;border:1px solid #eadbc2;border-radius:10px;background:#ffffff;">',
    '<a href="/products/mountain-sea-coffee-tea-mug?utm_source=unique_collection&amp;utm_medium=live_bridge&amp;utm_campaign=unique_collection_bridge_20260606" style="display:block;background:#f7f2ea;"><img src="https://cdn.shopify.com/s/files/1/0830/9394/6666/products/mountain-sea-coffee-tea-mug-987188.jpg?v=1702045924" alt="Mountain and Sea Ceramic Coffee Mug from CoffeifyMug" loading="eager" style="display:block;width:100%;height:220px;object-fit:cover;"></a>',
    '<div style="display:flex;flex:1;flex-direction:column;padding:12px;">',
    '<p style="margin:0 0 6px;font-size:12px;letter-spacing:0.06em;text-transform:uppercase;color:#7b6546;">Balanced art-led choice</p>',
    '<h3 style="margin:0 0 6px;font-size:18px;line-height:1.2;color:#1d2b24;">Mountain &amp; Sea</h3>',
    '<p style="margin:0 0 10px;color:#4b4f4c;font-size:14px;">Best if you want a distinctive ceramic illustration without jumping straight to the biggest or most decorative profile.</p>',
    '<div style="margin-top:auto;display:grid;gap:8px;">',
    '<a style="display:block;padding:10px 12px;border-radius:8px;background:#1f6b57;color:#ffffff;text-decoration:none;font-weight:600;text-align:center;" href="/products/mountain-sea-coffee-tea-mug?variant=47076772282666&amp;utm_source=unique_collection&amp;utm_medium=live_bridge&amp;utm_campaign=unique_collection_bridge_20260606">View Mountain &amp; Sea</a>',
    '<a style="display:block;padding:9px 12px;border-radius:8px;border:1px solid #c7d9d2;color:#1f6b57;text-decoration:none;font-weight:600;text-align:center;background:#f8fcfa;" href="/products/mountain-sea-coffee-tea-mug?utm_source=unique_collection&amp;utm_medium=live_bridge&amp;utm_campaign=unique_collection_bridge_20260606">Open product</a>',
    '</div>',
    '</div>',
    '</article>',
    '<article style="display:flex;flex-direction:column;overflow:hidden;border:1px solid #eadbc2;border-radius:10px;background:#ffffff;">',
    '<a href="/products/koi-fish-coffee-tea-mug?utm_source=unique_collection&amp;utm_medium=live_bridge&amp;utm_campaign=unique_collection_bridge_20260606" style="display:block;background:#f7f2ea;"><img src="https://cdn.shopify.com/s/files/1/0830/9394/6666/products/koi-fish-coffee-tea-mug-498336.jpg?v=1702045920" alt="Koi Fish Art Coffee Mug from CoffeifyMug" loading="eager" style="display:block;width:100%;height:220px;object-fit:cover;"></a>',
    '<div style="display:flex;flex:1;flex-direction:column;padding:12px;">',
    '<p style="margin:0 0 6px;font-size:12px;letter-spacing:0.06em;text-transform:uppercase;color:#7b6546;">Gift-forward art mug</p>',
    '<h3 style="margin:0 0 6px;font-size:18px;line-height:1.2;color:#1d2b24;">Koi Fish Mug</h3>',
    '<p style="margin:0 0 10px;color:#4b4f4c;font-size:14px;">Best if the buyer wants the most obviously unique surface design for gifting, display, or a more expressive morning mug.</p>',
    '<div style="margin-top:auto;display:grid;gap:8px;">',
    '<a style="display:block;padding:10px 12px;border-radius:8px;background:#1f6b57;color:#ffffff;text-decoration:none;font-weight:600;text-align:center;" href="/products/koi-fish-coffee-tea-mug?variant=47076799938858&amp;utm_source=unique_collection&amp;utm_medium=live_bridge&amp;utm_campaign=unique_collection_bridge_20260606">View Koi Fish Mug</a>',
    '<a style="display:block;padding:9px 12px;border-radius:8px;border:1px solid #c7d9d2;color:#1f6b57;text-decoration:none;font-weight:600;text-align:center;background:#f8fcfa;" href="/products/koi-fish-coffee-tea-mug?utm_source=unique_collection&amp;utm_medium=live_bridge&amp;utm_campaign=unique_collection_bridge_20260606">Open product</a>',
    '</div>',
    '</div>',
    '</article>',
    '</div>',
    '<p style="margin:14px 0 0;color:#4b4f4c;"><strong>Need the broader browse again?</strong> Keep scrolling the collection if you still want the full unique-mug grid, but use one of the three direct routes above if you already know whether you want bolder capacity, balanced artwork, or the most gift-forward design.</p>',
    '</div>'
  ].join('');

  function upgrade(){
    const main=document.getElementById('main');
    if(!main) return;
    const existing=document.getElementById('coffeifymug-unique-collection-live-bridge');
    if(existing && existing.getAttribute('data-growth-bridge')===bridgeMarker && existing.querySelector('a[href*="unique_collection_bridge_20260606"]')) return;
    if(existing){
      existing.setAttribute('data-growth-bridge', bridgeMarker);
      existing.innerHTML=bridgeHtml;
      return;
    }
    const bridge=document.createElement('section');
    bridge.id='coffeifymug-unique-collection-live-bridge';
    bridge.setAttribute('data-growth-bridge', bridgeMarker);
    bridge.innerHTML=bridgeHtml;
    main.insertBefore(bridge, main.firstChild);
  }

  function observe(){
    if(window.__coffeifymugUniqueCollectionBridgeObserver) return;
    const root=document.getElementById('main') || document.body;
    if(!root || !window.MutationObserver) return;
    const observer=new MutationObserver(()=>upgrade());
    observer.observe(root,{childList:true,subtree:true});
    window.__coffeifymugUniqueCollectionBridgeObserver=observer;
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', ()=>{upgrade();observe();}, {once:true});
  }else{
    upgrade();
    observe();
  }
  window.addEventListener('load', ()=>{upgrade();observe();}, {once:true});
  setTimeout(upgrade, 250);
  setTimeout(upgrade, 1500);
  setTimeout(upgrade, 4000);
  setTimeout(upgrade, 8000);
})();
/* asset_refresh_unique_round_media_20260606_20260605T224229Z */
;(()=>{
  const marker='landscape_product_fast_decision_bridge_20260606_mutation';
  const bridgeMarker='landscape_product_fast_decision_bridge_20260606_v1';
  if(window[marker]) return;
  window[marker]=true;
  if(window.location.pathname!=='/products/landscape-tall-coffee-tea-mug') return;

  const bridgeHtml=[
    '<div style="margin:0 0 14px;padding:12px 14px;border:1px solid #d8e4df;border-radius:8px;background:#f7fbf9;line-height:1.42;">',
    '<p style="margin:0 0 8px;"><strong>Fast decision:</strong> choose the tall mug for display-friendly height, or switch to the lower-price route if price is the blocker.</p>',
    '<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(126px,1fr));gap:8px;">',
    '<a style="display:block;padding:10px 12px;border-radius:8px;background:#1f6b57;color:#ffffff;text-decoration:none;font-weight:700;text-align:center;" href="/products/landscape-tall-coffee-tea-mug?variant=47076796236074&amp;utm_source=landscape_product&amp;utm_medium=fast_decision_bridge&amp;utm_campaign=landscape_product_20260606">View Landscape</a>',
    '<a style="display:block;padding:10px 12px;border-radius:8px;border:1px solid #c7d9d2;color:#1f6b57;text-decoration:none;font-weight:700;text-align:center;background:#ffffff;" href="/products/pleated-coffee-tea-cup?variant=47076746690858&amp;utm_source=landscape_product&amp;utm_medium=fast_decision_bridge&amp;utm_campaign=landscape_product_20260606">Pleated $23.90</a>',
    '<a style="display:block;padding:10px 12px;border-radius:8px;border:1px solid #d8c29d;color:#7b6546;text-decoration:none;font-weight:700;text-align:center;background:#fffaf0;" href="/pages/pick-a-mug-fast?utm_source=landscape_product&amp;utm_medium=fast_decision_bridge&amp;utm_campaign=landscape_product_20260606">Pick Fast</a>',
    '</div>',
    '<p style="margin:8px 0 0;font-size:13px;color:#4b4f4c;"><strong>Buyer review?</strong> <a href="/pages/coffeifymug-shop-share-fast?utm_source=landscape_product&amp;utm_medium=fast_decision_bridge&amp;utm_campaign=landscape_product_20260609">Open the Product Shop or Share Fast</a>.</p>',
    '</div>'
  ].join('');

  function install(){
    const priceBlock=document.querySelector('.product-info__block-item[data-block-type="price"]');
    if(!priceBlock || !priceBlock.parentElement) return;
    const existing=document.getElementById('coffeifymug-landscape-fast-decision-bridge');
    if(existing){
      existing.setAttribute('data-growth-bridge', bridgeMarker);
      existing.innerHTML=bridgeHtml;
      return;
    }
    const bridge=document.createElement('div');
    bridge.id='coffeifymug-landscape-fast-decision-bridge';
    bridge.className='product-info__block-item';
    bridge.setAttribute('data-growth-bridge', bridgeMarker);
    bridge.innerHTML=bridgeHtml;
    priceBlock.parentElement.insertBefore(bridge, priceBlock.nextSibling);
  }

  function observe(){
    if(window.__coffeifymugLandscapeFastDecisionBridgeObserver) return;
    const root=document.querySelector('.product-info__block-list') || document.body;
    if(!root || !window.MutationObserver) return;
    const observer=new MutationObserver(()=>install());
    observer.observe(root,{childList:true,subtree:true});
    window.__coffeifymugLandscapeFastDecisionBridgeObserver=observer;
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', ()=>{install();observe();}, {once:true});
  }else{
    install();
    observe();
  }
  window.addEventListener('load', ()=>{install();observe();}, {once:true});
  setTimeout(install, 250);
  setTimeout(install, 1500);
  setTimeout(install, 4000);
  setTimeout(install, 8000);
})();
;(()=>{
  const marker='homepage_fast_choice_bridge_20260606_mutation';
  const bridgeMarker='homepage_fast_choice_bridge_20260606_v1';
  if(window[marker]) return;
  window[marker]=true;
  if(window.location.pathname!=='/' && window.location.pathname!=='') return;

  const routes={
    pleated:'/products/pleated-coffee-tea-cup?variant=47076746690858&utm_source=homepage&utm_medium=fast_choice_bridge&utm_campaign=homepage_fast_choice_20260606',
    round:'/products/round-coffee-tea-mug?variant=47076797415722&utm_source=homepage&utm_medium=fast_choice_bridge&utm_campaign=homepage_fast_choice_20260606',
    pick:'/pages/pick-a-mug-fast?utm_source=homepage&utm_medium=fast_choice_bridge&utm_campaign=homepage_fast_choice_20260606',
    sample:'/pages/coffeifymug-shop-share-fast?utm_source=homepage&utm_medium=fast_choice_bridge&utm_campaign=homepage_fast_choice_20260609',
    fastPicks:'/pages/pick-a-mug-fast?utm_source=homepage&utm_medium=featured_collection_cta&utm_campaign=homepage_fast_picks_20260610'
  };

  const bridgeHtml=[
    '<div style="margin:12px 0 0;display:flex;flex-wrap:wrap;gap:8px;align-items:center;">',
    '<a style="display:inline-block;padding:9px 11px;border:1px solid rgba(255,255,255,.85);border-radius:8px;background:#ffffff;color:#111;text-decoration:none;font-weight:700;line-height:1.2;" href="'+routes.pleated+'">Pleated $23.90</a>',
    '<a style="display:inline-block;padding:9px 11px;border:1px solid rgba(255,255,255,.85);border-radius:8px;background:rgba(255,255,255,.08);color:#fff;text-decoration:none;font-weight:700;line-height:1.2;" href="'+routes.round+'">Round Mug</a>',
    '<a style="display:inline-block;padding:9px 11px;border:1px solid rgba(255,255,255,.7);border-radius:8px;background:rgba(0,0,0,.18);color:#fff;text-decoration:none;font-weight:700;line-height:1.2;" href="'+routes.pick+'">Pick Fast</a>',
    '<a style="display:inline-block;padding:9px 11px;border:1px solid rgba(255,255,255,.55);border-radius:8px;background:rgba(0,0,0,.08);color:#fff;text-decoration:none;font-weight:700;line-height:1.2;" href="'+routes.sample+'">Shop or Share Fast</a>',
    '</div>'
  ].join('');

  function rewriteHero(prose){
    const eyebrow=prose.querySelector('.h6');
    const title=prose.querySelector('.h1');
    if(eyebrow){
      eyebrow.textContent='LOWEST-PRICE FIRST OR PICK FAST';
      eyebrow.setAttribute('data-growth-bridge', bridgeMarker);
    }
    if(title){
      title.textContent='START WITH PLEATED $23.90 OR ROUND MUG';
      title.setAttribute('data-growth-bridge', bridgeMarker);
    }
    const group=prose.querySelector('.button-group');
    if(group){
      const links=group.querySelectorAll('a[href]');
      if(links[0]){
        links[0].textContent='ADD PLEATED $23.90';
        links[0].setAttribute('href', routes.pleated);
        links[0].setAttribute('data-growth-bridge', bridgeMarker);
      }
      if(links[1]){
        links[1].textContent='ADD ROUND MUG';
        links[1].setAttribute('href', routes.round);
        links[1].setAttribute('data-growth-bridge', bridgeMarker);
      }
      let bridge=document.getElementById('coffeifymug-homepage-fast-choice-bridge');
      if(!bridge){
        bridge=document.createElement('div');
        bridge.id='coffeifymug-homepage-fast-choice-bridge';
        group.parentElement.insertBefore(bridge, group.nextSibling);
      }
      bridge.setAttribute('data-growth-bridge', bridgeMarker);
      bridge.innerHTML=bridgeHtml;
    }
  }

  function rewriteFastPicks(main){
    const button=main.querySelector('featured-collections-carousel .justify-self-center a.button[href*="homepage-fast-mug-picks"]')
      || main.querySelector('featured-collections-carousel .justify-self-center a.button');
    if(!button) return;
    button.textContent='PICK A MUG FAST';
    button.setAttribute('href', routes.fastPicks);
    button.setAttribute('data-growth-bridge', bridgeMarker);
  }

  function install(){
    const main=document.getElementById('main') || document.querySelector('main') || document.body;
    if(!main) return;
    const prose=main.querySelector('.slideshow__slide-content .prose');
    if(prose){
      rewriteHero(prose);
    }
    rewriteFastPicks(main);
  }

  function observe(){
    if(window.__coffeifymugHomepageFastChoiceBridgeObserver) return;
    const root=document.getElementById('main') || document.body;
    if(!root || !window.MutationObserver) return;
    const observer=new MutationObserver(()=>install());
    observer.observe(root,{childList:true,subtree:true});
    window.__coffeifymugHomepageFastChoiceBridgeObserver=observer;
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', ()=>{install();observe();}, {once:true});
  }else{
    install();
    observe();
  }
  window.addEventListener('load', ()=>{install();observe();}, {once:true});
  setTimeout(install, 250);
  setTimeout(install, 1500);
  setTimeout(install, 4000);
  setTimeout(install, 8000);
})();
// homepage_fast_choice_rest_asset_cache_bust_20260606-031401
;(()=>{
  const marker="grey_article_public_body_fallback_20260608";
  const bridgeMarker="grey_article_public_body_fallback_20260608_v1";
  if(window[marker]) return;
  window[marker]=true;
  if(window.location.pathname!=="/blogs/news/grey-coffee-mugs-how-to-choose-the-right-one-for-home-or-desk") return;

  const cleanHtml="<p><em>Reading time: about 9 minutes</em></p><p>A mug can look right on a product page and still feel wrong in your hand at 7 a.m. We see that a lot with grey coffee mugs: the shade may be perfect, but the real decision comes down to the finish, the visual weight on a desk, and whether the mug feels easy to live with day after day.</p>\n<nav class=\"article-toc\" aria-label=\"Table of contents\"><strong>In this article:</strong><ul><li><a href=\"#what-makes-grey-coffee-mugs-appealing-for-everyday-use\">What makes grey coffee mugs appealing for everyday use?</a></li><li><a href=\"#how-do-the-three-coffeifymug-options-differ-in-hand-feel-and-desk-presence\">How do the three CoffeifyMug options differ in hand feel and desk presence?</a></li><li><a href=\"#which-grey-finish-works-better-plain-ceramic-or-printed-artwork\">Which grey finish works better: plain ceramic or printed artwork?</a></li><li><a href=\"#what-should-you-check-before-buying-a-grey-mug-for-desk-use\">What should you check before buying a grey mug for desk use?</a></li><li><a href=\"#are-grey-coffee-mugs-good-gifts\">Are grey coffee mugs good gifts?</a></li><li><a href=\"#how-should-you-care-for-ceramic-grey-mugs\">How should you care for ceramic grey mugs?</a></li><li><a href=\"#which-grey-coffee-mug-should-you-pick-for-your-situation\">Which grey coffee mug should you pick for your situation?</a></li></ul></nav><p>At CoffeifyMug, we think of grey-toned mugs as everyday ceramic pieces first. They should sit well on a kitchen counter, look calm near a laptop, and still feel presentable when you hand one to someone as a gift. If you are comparing options, start with the three styles we currently feature: the <a href=\"https://coffeifymug.com/products/round-coffee-tea-mug\">Round Coffee Tea Mug</a>, the <a href=\"https://coffeifymug.com/products/elk-and-moon-coffee-tea-mug\">Elk and Moon Coffee Tea Mug</a>, and the <a href=\"https://coffeifymug.com/products/koi-fish-coffee-tea-mug\">Koi Fish Coffee Tea Mug</a>.</p><h2 id=\"what-makes-grey-coffee-mugs-appealing-for-everyday-use\">What makes grey coffee mugs appealing for everyday use?</h2><p>Grey is one of the easiest mug colors to live with because it sits between bright white and dark black. It reads clean, but not cold. It can feel calm on a kitchen shelf, restrained on an office desk, and easy to pair with other dishes without looking too matched or too decorative.</p><p>For everyday buyers, that matters for three reasons:</p><ul><li><strong>It hides minor visual clutter better than bright white.</strong> Small coffee rings, spoon marks, and desk dust are less obvious on a mid-grey surface.</li><li><strong>It works in shared spaces.</strong> Grey fits modern kitchens, neutral offices, and gift sets without needing a specific theme.</li><li><strong>It can look either minimal or characterful.</strong> A plain round mug feels quiet, while a printed grey mug can still show personality.</li></ul><p>The trade-off is simple. Grey coffee mugs are usually chosen for balance, not drama. If you want a mug to become the center of the table, a high-contrast color or a bold glaze may be a better fit. If you want a mug that blends in and still looks considered, grey is usually the safer buy.</p><h2 id=\"how-do-the-three-coffeifymug-options-differ-in-hand-feel-and-desk-presence\">How do the three CoffeifyMug options differ in hand feel and desk presence?</h2><p>We look at mugs the same way customers do: in the hand, on the desk, and after repeated use. Even when two mugs share the same ceramic category, they can feel different because of shape, printed artwork, and how much visual weight they carry.</p><table><thead><tr><th>Mug</th><th>What stands out visually</th><th>Best everyday use</th><th>Trade-off</th></tr></thead><tbody><tr><td>Round Coffee Tea Mug</td><td>Clean, simple profile</td><td>Minimal home or office use</td><td>Less decorative if you want a gift with more personality</td></tr><tr><td>Elk and Moon Coffee Tea Mug</td><td>Distinct illustrated character</td><td>Gift giving and desk display</td><td>More specific style, so it suits fewer tastes</td></tr><tr><td>Koi Fish Coffee Tea Mug</td><td>Patterned, art-forward look</td><td>People who want a mug with more visual interest</td><td>Not ideal if you want a plain, neutral cup</td></tr></tbody></table><p>The <a href=\"https://coffeifymug.com/products/round-coffee-tea-mug\">Round Coffee Tea Mug</a> is the most straightforward of the three. In our experience, this is the kind of mug that disappears into daily life in a good way. It suits a home office, a shared kitchen, or anyone who wants the mug to feel calm rather than attention-grabbing.</p><p>The <a href=\"https://coffeifymug.com/products/elk-and-moon-coffee-tea-mug\">Elk and Moon Coffee Tea Mug</a> adds more personality, which makes it stronger as a gift or a display piece on a desk shelf. The downside is that it feels more specific. If the person likes rustic or nature-inspired artwork, it lands well. If they want a pure minimalist look, it may feel busy.</p><p>The <a href=\"https://coffeifymug.com/products/koi-fish-coffee-tea-mug\">Koi Fish Coffee Tea Mug</a> sits closer to an art-forward everyday mug. That can be a real plus for someone who wants a grey mug with movement and detail, not just a plain surface. The limitation is the same one that applies to any patterned mug: the design narrows the audience a bit.</p><h2 id=\"which-grey-finish-works-better-plain-ceramic-or-printed-artwork\">Which grey finish works better: plain ceramic or printed artwork?</h2><p>Grey coffee mugs can feel very different depending on whether the grey tone is the main event or just the backdrop for artwork. A plain ceramic finish usually reads quieter. Printed mugs bring more contrast, which can be useful if you want the mug to feel like a small personal object rather than a neutral tool.</p><p>Here is the practical way we suggest choosing:</p><ol><li><strong>Choose plain grey if you want the mug to blend in.</strong> This is best for work desks, open shelving, and mixed dish sets.</li><li><strong>Choose illustrated grey if you want the mug to feel giftable.</strong> Artwork gives the mug more identity when it is unboxed.</li><li><strong>Choose the simplest shape if stacking and cabinet storage matter.</strong> Less visual complexity usually makes a mug easier to coordinate with the rest of the kitchen.</li></ol><p>Grey also changes how texture reads. A smooth ceramic finish feels more polished and modern. A design-heavy mug can hide small use marks better, but it also shows if the buyer prefers a less decorative everyday cup. None of these are automatically better. The right choice depends on where the mug lives most of the time: in a cupboard, on a desk, or in a gift box.</p><h2 id=\"what-should-you-check-before-buying-a-grey-mug-for-desk-use\">What should you check before buying a grey mug for desk use?</h2><p>Desk mugs have different demands from kitchen mugs. They need to look tidy next to a keyboard, avoid taking up too much visual space, and feel stable when you reach for them one-handed.</p><p>Before you choose from our collection, we suggest checking these points:</p><ul><li><strong>Base stability.</strong> A mug that sits securely is easier to trust on a crowded desk.</li><li><strong>Handle shape.</strong> You want a handle that feels comfortable for repeated coffee breaks, not just a one-time unboxing.</li><li><strong>Color tone.</strong> A cooler grey can look more modern; a warmer grey can feel softer and more home-like.</li><li><strong>Design load.</strong> Too much contrast can distract on a small workspace, while a quiet grey finish usually blends better.</li></ul><p>That is why the <a href=\"https://coffeifymug.com/collections/all\">full CoffeifyMug collection</a> is worth browsing if you are matching a mug to a desk setup or looking for a gift with a specific mood. The visual fit matters almost as much as the drinkware itself.</p><p>If you want more help with fit as well as style, compare how much surface presence you want on the desk, how calm the finish looks beside your usual setup, and whether a simpler or more decorative profile suits your routine better.</p><h2 id=\"are-grey-coffee-mugs-good-gifts\">Are grey coffee mugs good gifts?</h2><p>Yes, but only if you match the design to the person. Grey is one of the safest gift colors because it is neutral, modern, and easy to place in most homes. The risk is that a plain grey mug can feel generic if the recipient likes bold colors or novelty drinkware.</p><p>We usually think about gift suitability in this order:</p><ul><li><strong>For coworkers or casual gifts:</strong> a simple grey ceramic mug is easy to give because it does not feel overly personal.</li><li><strong>For nature or illustration fans:</strong> a design like the <a href=\"https://coffeifymug.com/products/elk-and-moon-coffee-tea-mug\">Elk and Moon Coffee Tea Mug</a> gives the gift more personality without leaving the everyday mug category.</li><li><strong>For people who like calm home decor:</strong> the <a href=\"https://coffeifymug.com/products/round-coffee-tea-mug\">Round Coffee Tea Mug</a> is the least risky option because it looks clean and easy to live with.</li></ul><p>One limitation is worth saying plainly: grey mugs are not the best choice if you want a very cheerful, high-contrast gift that feels instantly playful. They work better for people who appreciate muted color, practical objects, and a mug they can use every day instead of storing away.</p><h2 id=\"how-should-you-care-for-ceramic-grey-mugs\">How should you care for ceramic grey mugs?</h2><p>We always recommend gentle hand care for mugs if the goal is to keep the finish looking good as long as possible. Ceramic mugs are durable for daily use, but the surface still benefits from a careful wash routine, especially when the mug has artwork or a printed design.</p><p>A simple care routine looks like this:</p><ol><li>Rinse the mug soon after use so tea or coffee residue does not dry onto the surface.</li><li>Wash with mild dish soap and a soft sponge rather than an abrasive pad.</li><li>Dry it fully before stacking or storing it in a cabinet.</li><li>Avoid hard knocks against sinks, taps, and crowded dish racks, since chips usually start at the rim or base.</li></ol><p>That last point matters. The most common wear we see on everyday ceramic mugs is not sudden breakage; it is small rim chips, glaze scuffs, or marks from frequent contact with other dishes. Gentle hand care helps reduce that and keeps the finish looking cleaner over time.</p><p>For buyers comparing everyday feel as well as care, it helps to think about whether you want the mug to feel lighter and visually quieter or slightly more present on a shelf or desk.</p><h2 id=\"which-grey-coffee-mug-should-you-pick-for-your-situation\">Which grey coffee mug should you pick for your situation?</h2><p>Here is the quickest way to narrow it down:</p><ul><li><strong>Choose the Round Coffee Tea Mug</strong> if you want the cleanest, most neutral grey coffee mug for home or desk use.</li><li><strong>Choose the Elk and Moon Coffee Tea Mug</strong> if you want a more giftable mug with a distinct illustrated feel.</li><li><strong>Choose the Koi Fish Coffee Tea Mug</strong> if you want grey coffee mugs with more visual movement and art-like character.</li></ul><p>Our advice is to think about where the mug will live most days. A desk mug should feel calm and unobtrusive. A gift mug should feel intentional when it is opened. A home mug should be easy to reach for without thinking. Grey works across all three, but the best version depends on how much visual personality you want every morning.</p><h2 id=\"frequently-asked-questions\">Frequently asked questions</h2><h3>Are grey coffee mugs good for everyday use?</h3><p>Yes. Grey coffee mugs are practical because they are neutral, easy to match, and less visually harsh than bright white or black in many kitchens and offices. They work best for people who want a mug that feels calm and usable rather than decorative first.</p><h3>Which grey mug is best for a desk?</h3><p>The Round Coffee Tea Mug is the safest choice for a desk because it has the cleanest look and the least visual noise. If you want the mug to act like a small d\u00e9cor piece on the desk, the Elk and Moon Coffee Tea Mug or Koi Fish Coffee Tea Mug gives you more personality.</p><h3>Are grey ceramic mugs good gifts?</h3><p>Yes, especially for coworkers, housewarmings, and low-pressure gifting. Grey is neutral and easy to place in most homes, but a printed design is usually better than a plain mug if you want the gift to feel more personal.</p><h3>How should I clean a printed grey mug?</h3><p>Use mild dish soap, a soft sponge, and gentle drying. That approach helps protect the ceramic finish and reduces the chance of cosmetic wear on artwork or glaze over time.</p><h3>What is the downside of choosing grey coffee mugs?</h3><p>The main downside is that grey can feel too quiet for shoppers who want a bold, colorful statement piece. Grey mugs are best when you value versatility, desk-friendly style, and everyday use over a high-energy look.</p><p>If you are ready to compare the actual options, start with the <a href=\"https://coffeifymug.com/collections/all\">full CoffeifyMug collection</a>, then open the Round, Elk and Moon, and Koi Fish mugs side by side. That is the fastest way to decide which grey coffee mug fits your kitchen, desk, or gift list best.</p>\n<script type=\"application/ld+json\">{\"@context\": \"https://schema.org\", \"@type\": \"BlogPosting\", \"headline\": \"Grey Coffee Mugs: How to Choose the Right One for Home or Desk\", \"description\": \"Grey coffee mugs for home or desk use, with real comparisons on finish, feel, gifting, and care before you buy.\", \"datePublished\": \"2026-06-08T01:18:47.466761Z\", \"dateModified\": \"2026-06-08T01:18:47.466761Z\", \"inLanguage\": \"en\", \"author\": {\"@type\": \"Organization\", \"name\": \"CoffeifyMug Team\"}, \"keywords\": \"Grey Coffee Mugs, Ceramic Mugs, Desk Coffee Mugs\", \"publisher\": {\"@type\": \"Organization\", \"name\": \"CoffeifyMug\", \"url\": \"https://coffeifymug.com\"}, \"mainEntityOfPage\": {\"@type\": \"WebPage\", \"@id\": \"https://coffeifymug.com/blogs/news/grey-coffee-mugs-how-to-choose-the-right-one-for-home-or-desk\"}, \"url\": \"https://coffeifymug.com/blogs/news/grey-coffee-mugs-how-to-choose-the-right-one-for-home-or-desk\"}</script>\n<script type=\"application/ld+json\">{\"@context\": \"https://schema.org\", \"@type\": \"FAQPage\", \"mainEntity\": [{\"@type\": \"Question\", \"name\": \"Are grey coffee mugs good for everyday use?\", \"acceptedAnswer\": {\"@type\": \"Answer\", \"text\": \"Yes. Grey coffee mugs are practical because they are neutral, easy to match, and less visually harsh than bright white or black in many kitchens and offices. They work best for people who want a mug that feels calm and usable rather than decorative first.\"}}, {\"@type\": \"Question\", \"name\": \"Which grey mug is best for a desk?\", \"acceptedAnswer\": {\"@type\": \"Answer\", \"text\": \"The Round Coffee Tea Mug is the safest choice for a desk because it has the cleanest look and the least visual noise. If you want the mug to act like a small d\u00e9cor piece on the desk, the Elk and Moon Coffee Tea Mug or Koi Fish Coffee Tea Mug gives you more personality.\"}}, {\"@type\": \"Question\", \"name\": \"Are grey ceramic mugs good gifts?\", \"acceptedAnswer\": {\"@type\": \"Answer\", \"text\": \"Yes, especially for coworkers, housewarmings, and low-pressure gifting. Grey is neutral and easy to place in most homes, but a printed design is usually better than a plain mug if you want the gift to feel more personal.\"}}, {\"@type\": \"Question\", \"name\": \"How should I clean a printed grey mug?\", \"acceptedAnswer\": {\"@type\": \"Answer\", \"text\": \"Use mild dish soap, a soft sponge, and gentle drying. That approach helps protect the ceramic finish and reduces the chance of cosmetic wear on artwork or glaze over time.\"}}, {\"@type\": \"Question\", \"name\": \"What is the downside of choosing grey coffee mugs?\", \"acceptedAnswer\": {\"@type\": \"Answer\", \"text\": \"The main downside is that grey can feel too quiet for shoppers who want a bold, colorful statement piece. Grey mugs are best when you value versatility, desk-friendly style, and everyday use over a high-energy look.\"}}]}</script>";
  const staleTexts=[
    "If you want more help with size as well as style, our size guides can narrow the choice further: 10 oz Coffee Mugs: How to Choose the Right One for Daily Use and 12 oz Coffee Mugs: How to Choose the Right Mug for Daily Use. Those pieces are useful if you know the color you want but are still deciding on capacity.",
    "That last point matters. The most common wear we see on everyday ceramic mugs is not sudden breakage; it is small rim chips, glaze scuffs, or marks from frequent contact with other dishes. Gentle hand care helps reduce that. If you prefer to run all drinkware through the dishwasher, choose a mug only if you are comfortable with the possibility of faster cosmetic wear over time.",
    "For buyers comparing everyday drinking volume as well as material and care, our related guides on 11 Ounce Coffee Mugs: Size, Fit, and Best Picks for Daily Use and 14 Ounce Coffee Mugs for Daily Coffee, Tea, and Desk Use can help you decide whether you want a lighter everyday mug or one with a little more room."
  ];
  const jsonReplacements=[
    ["If you want more help with size as well as style, our size guides can narrow the choice further: 10 oz Coffee Mugs: How to Choose the Right One for Daily Use and 12 oz Coffee Mugs: How to Choose the Right Mug for Daily Use. Those pieces are useful if you know the color you want but are still deciding on capacity.", "If you want more help with fit as well as style, compare how much surface presence you want on the desk, how calm the finish looks beside your usual setup, and whether a simpler or more decorative profile suits your routine better."],
    ["That last point matters. The most common wear we see on everyday ceramic mugs is not sudden breakage; it is small rim chips, glaze scuffs, or marks from frequent contact with other dishes. Gentle hand care helps reduce that. If you prefer to run all drinkware through the dishwasher, choose a mug only if you are comfortable with the possibility of faster cosmetic wear over time.", "That last point matters. The most common wear we see on everyday ceramic mugs is not sudden breakage; it is small rim chips, glaze scuffs, or marks from frequent contact with other dishes. Gentle hand care helps reduce that and keeps the finish looking cleaner over time."],
    ["For buyers comparing everyday drinking volume as well as material and care, our related guides on 11 Ounce Coffee Mugs: Size, Fit, and Best Picks for Daily Use and 14 Ounce Coffee Mugs for Daily Coffee, Tea, and Desk Use can help you decide whether you want a lighter everyday mug or one with a little more room.", "For buyers comparing everyday feel as well as care, it helps to think about whether you want the mug to feel lighter and visually quieter or slightly more present on a shelf or desk."]
  ];

  function patchProse(){
    const prose=document.querySelector('.shopify-section--main-article .prose');
    if(!prose) return false;
    const text=(prose.textContent||'').replace(/\s+/g,' ').trim();
    const needsPatch=staleTexts.some((needle)=>text.includes(needle));
    if(!needsPatch){
      if(prose.getAttribute('data-growth-bridge')===bridgeMarker) return false;
      prose.setAttribute('data-growth-bridge', bridgeMarker);
      return false;
    }
    prose.innerHTML=cleanHtml;
    prose.setAttribute('data-growth-bridge', bridgeMarker);
    return true;
  }

  function patchJsonLd(){
    let changed=false;
    document.querySelectorAll('script[type="application/ld+json"]').forEach((script)=>{
      let text=script.textContent||'';
      let localChange=false;
      jsonReplacements.forEach(([oldText,newText])=>{
        if(text.includes(oldText)){
          text=text.split(oldText).join(newText);
          localChange=true;
        }
      });
      if(localChange){
        script.textContent=text;
        script.setAttribute('data-growth-bridge', bridgeMarker);
        changed=true;
      }
    });
    return changed;
  }

  function apply(){
    patchProse();
    patchJsonLd();
  }

  function observe(){
    if(window.__coffeifymugGreyArticleFallbackObserver) return;
    const root=document.getElementById('main') || document.body;
    if(!root || !window.MutationObserver) return;
    const observer=new MutationObserver(()=>apply());
    observer.observe(root,{childList:true,subtree:true});
    window.__coffeifymugGreyArticleFallbackObserver=observer;
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', ()=>{apply();observe();}, {once:true});
  }else{
    apply();
    observe();
  }
  window.addEventListener('load', ()=>{apply();observe();}, {once:true});
  setTimeout(apply, 250);
  setTimeout(apply, 1500);
  setTimeout(apply, 4000);
  setTimeout(apply, 8000);
})();
;(()=>{
  const marker='museum_sample_asset_cleanup_20260609';
  const bridgeMarker='museum_sample_asset_cleanup_20260609_v1';
  if(window[marker]) return;
  window[marker]=true;
  if(window.location.pathname!=='/pages/museum-shop-mug-sample-set') return;

  const bridgeHtml=[
    '<div style="margin:0 auto 18px;max-width:1080px;padding:14px 16px;border:1px solid #d8c29d;background:#fffdf8;border-radius:10px;line-height:1.45;box-shadow:0 8px 22px rgba(29,43,36,0.06);">',
    '<p style="margin:0 0 8px;"><strong>Primary buyer route:</strong> <a href="/products/pleated-coffee-tea-cup?variant=47076746690858&amp;utm_source=museum_sample_set&amp;utm_medium=asset_bridge&amp;utm_campaign=museumshop2026_simplified_20260609">View the Pleated Cup sample at $23.90</a> if you want the lowest-commitment first order.</p>',
    '<p style="margin:0 0 8px;"><strong>Everyday backup:</strong> <a href="/products/round-coffee-tea-mug?variant=47076797415722&amp;utm_source=museum_sample_set&amp;utm_medium=asset_bridge&amp;utm_campaign=museumshop2026_simplified_20260609">View the Round Mug sample</a> for the broadest day-to-day fit.</p>',
    '<p style="margin:0;"><strong>Forwardable review page:</strong> <a href="/pages/coffeifymug-editor-buyer-asset-packet?utm_source=museum_sample_set&amp;utm_medium=asset_bridge&amp;utm_campaign=museumshop2026_simplified_20260609">Open the Editor &amp; Buyer Asset Packet</a> or <a href="/pages/coffeifymug-product-media-kit?utm_source=museum_sample_set&amp;utm_medium=asset_bridge&amp;utm_campaign=museumshop2026_simplified_20260609">Product Shop or Share Fast</a>.</p>',
    '</div>'
  ].join('');

  function install(){
    const main=document.getElementById('main') || document.body;
    if(!main) return;
    let existing=document.getElementById('coffeifymug-museum-route-live-bridge');
    if(existing){
      existing.setAttribute('data-growth-bridge', bridgeMarker);
      existing.innerHTML=bridgeHtml;
      return;
    }
    existing=document.createElement('section');
    existing.id='coffeifymug-museum-route-live-bridge';
    existing.setAttribute('data-growth-bridge', bridgeMarker);
    existing.innerHTML=bridgeHtml;
    main.insertBefore(existing, main.firstChild);
  }

  function cleanup(){
    const main=document.getElementById('main') || document.body;
    if(!main) return;

    main.querySelectorAll('p').forEach((p)=>{
      const text=(p.innerText||p.textContent||'').trim();
      if(text.startsWith('Quick answer:')){
        p.style.display='none';
        p.setAttribute('data-growth-bridge', bridgeMarker);
      }
      if(text.startsWith('Lowest-commitment first sample:')){
        p.innerHTML=p.innerHTML.replace('Lowest-commitment first sample:', 'Primary buyer route:');
      }
    });

    const listItems=Array.from(main.querySelectorAll('li'));
    listItems.forEach((li)=>{
      const text=(li.innerText||li.textContent||'').trim();
      if(
        text.includes('2-Mug Starter Set') ||
        text.includes('3-Piece Sample Set') ||
        text.includes('Need the safest first compare order?') ||
        text.includes('Need one complete first-pass review shipment?')
      ){
        li.remove();
      }
    });

    Array.from(main.querySelectorAll('h2')).forEach((h2)=>{
      const text=(h2.innerText||h2.textContent||'').trim();
      if(text==='Use the shortest route that matches the visit'){
        const next=h2.nextElementSibling;
        if(next && next.tagName==='UL' && (next.innerText||'').includes('2-Mug Starter Set')){
          next.remove();
        }
        h2.remove();
      }
    });
  }

  function apply(){
    install();
    cleanup();
  }

  function observe(){
    if(window.__coffeifymugMuseumRouteCleanupObserver) return;
    const root=document.getElementById('main') || document.body;
    if(!root || !window.MutationObserver) return;
    const observer=new MutationObserver(()=>apply());
    observer.observe(root,{childList:true,subtree:true});
    window.__coffeifymugMuseumRouteCleanupObserver=observer;
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', ()=>{apply();observe();}, {once:true});
  }else{
    apply();
    observe();
  }
  window.addEventListener('load', ()=>{apply();observe();}, {once:true});
  setTimeout(apply, 250);
  setTimeout(apply, 1500);
  setTimeout(apply, 4000);
  setTimeout(apply, 8000);
})();
;(()=>{
  const marker='media_kit_dom_cleanup_20260609';
  const bridgeMarker='media_kit_dom_cleanup_20260609_v2';
  const targetPaths=['/pages/coffeifymug-product-media-kit','/pages/coffeifymug-shop-share-fast'];
  const shopShareRoute='/pages/coffeifymug-shop-share-fast?utm_source=product_media_kit&amp;utm_medium=dom_cleanup&amp;utm_campaign=media_kit_cleanup_20260609';
  const assetPacketRoute='/pages/coffeifymug-editor-buyer-asset-packet?utm_source=product_media_kit&amp;utm_medium=dom_cleanup&amp;utm_campaign=media_kit_cleanup_20260609';
  if(window[marker]) return;
  window[marker]=true;
  if(targetPaths.indexOf(window.location.pathname)===-1) return;

  function rewriteLegacyAnchors(root){
    if(!root) return;
    root.querySelectorAll('a[href]').forEach((link)=>{
      const rawHref=link.getAttribute('href') || '';
      const href=rawHref.replace(/&amp;/g,'&');
      if(href.indexOf('/pages/coffeifymug-product-media-kit')===-1 && href.indexOf('/pages/museum-shop-mug-sample-set')===-1) return;
      link.setAttribute('href', shopShareRoute);
      const text=(link.textContent || '').trim();
      if(!text || /product media kit|museum shop mug sample set|buyer sample set/i.test(text)){
        link.textContent='open Shop or Share Fast';
      }
      link.setAttribute('data-growth-bridge', bridgeMarker);
    });
  }

  function cleanup(){
    const main=document.getElementById('main') || document.body;
    if(!main) return;

    const removeNode=(node)=>{
      if(!node) return;
      if(node.id==='coffeifymug-media-kit-visual-strip') return;
      node.remove();
    };

    main.querySelectorAll('a[href*="/products/landscape-tall-coffee-tea-mug?variant=47076796236074"]').forEach((link)=>{
      const text=(link.textContent||'').trim();
      if(text==='Add Tall Mug'){
        link.textContent='Add Landscape Tall';
      }
    });

    const heading=main.querySelector('h1');
    if(heading){
      heading.textContent='CoffeifyMug Shop or Share Fast';
      heading.setAttribute('data-growth-bridge', bridgeMarker);
    }
    if(typeof document.title === 'string' && /Product Media Kit/i.test(document.title)){
      document.title=document.title.replace(/Product Media Kit/gi,'Shop or Share Fast');
    }

    main.querySelectorAll('p').forEach((p)=>{
      const text=(p.innerText||p.textContent||'').trim();
      if(
        text.startsWith('Quick answer:') ||
        text.startsWith('Use this media kit to shop, share, or review CoffeifyMug faster:')
      ){
        p.style.display='none';
        p.setAttribute('data-growth-bridge', bridgeMarker);
      }
    });

    main.querySelectorAll('a[href*="/pages/museum-shop-mug-sample-set"]').forEach((link)=>{
      const block = link.closest('div[style*="border"]') || link.closest('li') || link.closest('p');
      removeNode(block);
    });

    Array.from(main.querySelectorAll('div,ul')).forEach((node)=>{
      const text=(node.innerText||node.textContent||'').trim();
      if(!text) return;
      if(
        text.includes('2-Mug Starter Set') ||
        text.includes('3-Piece Starter Set') ||
        text.includes('Open the Museum Shop Mug Sample Set') ||
        text.includes('Buyer Sample Set')
      ){
        const block = node.closest('div[style*="border"]') || node;
        removeNode(block);
      }
    });

    const supportLinks=Array.from(main.querySelectorAll('a[href*="/pages/coffeifymug-editor-buyer-asset-packet"]'));
    supportLinks.forEach((link)=>{
      const block = link.closest('div[style*="border"]');
      if(block){
        const text=(block.innerText||block.textContent||'').trim();
        if(text.includes('Open the Museum Shop Mug Sample Set')){
          removeNode(block);
        }
      }
    });

    rewriteLegacyAnchors(main);
  }

  function installSupportNote(){
    const main=document.getElementById('main') || document.body;
    if(!main) return;
    let existing=document.getElementById('coffeifymug-media-kit-dom-cleanup-note');
    const html=[
      '<div style="margin:0 0 14px;padding:12px 14px;border:1px solid #d8e4df;border-radius:8px;background:#f7fbf9;line-height:1.45;">',
      '<p style="margin:0 0 8px;"><strong>Clean forwardable route:</strong> <a href="'+shopShareRoute+'">stay on Shop or Share Fast</a> for editor, buyer, and reviewer context.</p>',
      '<p style="margin:0;"><strong>Need one-page handoff?</strong> <a href="'+assetPacketRoute+'">Open the Editor &amp; Buyer Asset Packet</a>.</p>',
      '</div>'
    ].join('');
    if(existing){
      existing.setAttribute('data-growth-bridge', bridgeMarker);
      existing.innerHTML=html;
      return;
    }
    const anchor=main.querySelector('#coffeifymug-media-kit-visual-strip') || main.firstElementChild;
    existing=document.createElement('section');
    existing.id='coffeifymug-media-kit-dom-cleanup-note';
    existing.setAttribute('data-growth-bridge', bridgeMarker);
    existing.innerHTML=html;
    if(anchor && anchor.parentNode===main){
      anchor.insertAdjacentElement('afterend', existing);
    }else{
      main.insertBefore(existing, main.firstChild);
    }
  }

  function apply(){
    cleanup();
    installSupportNote();
  }

  function observe(){
    if(window.__coffeifymugMediaKitDomCleanupObserver) return;
    const root=document.getElementById('main') || document.body;
    if(!root || !window.MutationObserver) return;
    const observer=new MutationObserver(()=>apply());
    observer.observe(root,{childList:true,subtree:true});
    window.__coffeifymugMediaKitDomCleanupObserver=observer;
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', ()=>{apply();observe();}, {once:true});
  }else{
    apply();
    observe();
  }
  window.addEventListener('load', ()=>{apply();observe();}, {once:true});
  setTimeout(apply, 250);
  setTimeout(apply, 1500);
  setTimeout(apply, 4000);
  setTimeout(apply, 8000);
})();
// homepage_fast_choice_asset_cache_bust_20260609-043444
;(()=>{
  const marker='global_shop_share_route_cleanup_20260609';
  const bridgeMarker='global_shop_share_route_cleanup_20260609_v1';
  const legacyHints=['/pages/coffeifymug-product-media-kit','https://coffeifymug.com/pages/coffeifymug-product-media-kit'];
  const shopShareRoute='/pages/coffeifymug-shop-share-fast?utm_source=global_route_cleanup&amp;utm_medium=nav_footer_cleanup&amp;utm_campaign=shop_share_global_20260609';
  if(window[marker]) return;
  window[marker]=true;

  const labelMap=new Map([
    ['media kit','Shop or Share Fast'],
    ['product media kit','Shop or Share Fast'],
    ['coffeifymug product media kit','Shop or Share Fast'],
    ['view the media kit','open Shop or Share Fast'],
    ['open the product media kit','open Shop or Share Fast']
  ]);

  function normalizeHref(rawHref){
    return (rawHref || '').replace(/&amp;/g,'&');
  }

  function shouldRewriteHref(href){
    return legacyHints.some((hint)=>href.indexOf(hint)!==-1);
  }

  function rewriteAnchor(link){
    if(!link || !link.getAttribute) return;
    const rawHref=link.getAttribute('href') || '';
    const href=normalizeHref(rawHref);
    const text=(link.textContent || '').trim();
    const lower=text.toLowerCase();
    const rewriteHref=shouldRewriteHref(href);

    if(rewriteHref){
      link.setAttribute('href', shopShareRoute);
      link.setAttribute('data-growth-bridge', bridgeMarker);
    }

    if(labelMap.has(lower) && (rewriteHref || /media kit/i.test(text))){
      link.textContent=labelMap.get(lower);
      link.setAttribute('data-growth-bridge', bridgeMarker);
    }
  }

  function rewriteFooterCopy(){
    const footerNodes=document.querySelectorAll('footer p, .footer__block p, .footer__block .prose p');
    footerNodes.forEach((node)=>{
      if(!node || !node.innerHTML) return;
      if(node.innerHTML.indexOf('View the media kit')===-1 && node.innerHTML.indexOf('Media Kit:')===-1) return;
      let html=node.innerHTML;
      html=html.replace(/Media Kit:/g,'Shop Fast:');
      html=html.replace(/View the media kit/gi,'open Shop or Share Fast');
      html=html.replace(/Product Media Kit/gi,'Shop or Share Fast');
      if(html!==node.innerHTML){
        node.innerHTML=html;
        node.setAttribute('data-growth-bridge', bridgeMarker);
      }
    });
  }

  function apply(){
    document.querySelectorAll('a[href]').forEach(rewriteAnchor);
    rewriteFooterCopy();
  }

  function observe(){
    if(window.__coffeifymugGlobalShopShareCleanupObserver) return;
    const root=document.body;
    if(!root || !window.MutationObserver) return;
    const observer=new MutationObserver(()=>apply());
    observer.observe(root,{childList:true,subtree:true});
    window.__coffeifymugGlobalShopShareCleanupObserver=observer;
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', ()=>{apply();observe();}, {once:true});
  }else{
    apply();
    observe();
  }
  window.addEventListener('load', ()=>{apply();observe();}, {once:true});
  setTimeout(apply, 250);
  setTimeout(apply, 1500);
  setTimeout(apply, 4000);
  setTimeout(apply, 8000);
})();
;(()=>{
  const marker='media_kit_shop_share_asset_redirect_20260610';
  const bridgeMarker='media_kit_shop_share_asset_redirect_20260610_v1';
  const sourcePath='/pages/coffeifymug-product-media-kit';
  const targetPath='/pages/coffeifymug-shop-share-fast';
  if(window[marker]) return;
  window[marker]=true;
  if(window.location.pathname!==sourcePath) return;

  const params=new URLSearchParams(window.location.search || '');
  if(params.get('stay_on_media_kit')==='1' || params.get('preview_media_kit')==='1') return;

  if(!params.has('utm_source')) params.set('utm_source','product_media_kit');
  if(!params.has('utm_medium')) params.set('utm_medium','stale_handle_redirect');
  if(!params.has('utm_campaign')) params.set('utm_campaign','shop_share_fast_redirect_20260610');
  params.set('redirected_from','product_media_kit_asset_cache');

  const target=targetPath+'?'+params.toString();
  if(window.location.pathname + window.location.search === target) return;
  window.location.replace(target);
  document.documentElement.setAttribute('data-growth-bridge', bridgeMarker);
})();
;(()=>{
  const marker='media_kit_dom_cleanup_20260610_round_green';
  const bridgeMarker='media_kit_dom_cleanup_20260610_round_green_v1';
  const targetPaths=['/pages/coffeifymug-product-media-kit','/pages/coffeifymug-shop-share-fast'];
  const shopShareRoute='/pages/coffeifymug-shop-share-fast?utm_source=product_media_kit&amp;utm_medium=dom_cleanup&amp;utm_campaign=round_green_brunch_support_20260610';
  const assetPacketRoute='/pages/coffeifymug-editor-buyer-asset-packet?utm_source=product_media_kit&amp;utm_medium=dom_cleanup&amp;utm_campaign=round_green_brunch_support_20260610';
  const roundGreenProductRoute='/products/round-coffee-tea-mug?variant=47076797415722&amp;utm_source=product_media_kit&amp;utm_medium=dom_cleanup&amp;utm_campaign=round_green_brunch_support_20260610';
  const roundGreenCartRoute='/products/round-coffee-tea-mug?variant=47076797415722&amp;utm_source=product_media_kit&amp;utm_medium=dom_cleanup&amp;utm_campaign=round_green_brunch_support_20260610';
  const pleatedCartRoute='/products/pleated-coffee-tea-cup?variant=47076746690858&amp;utm_source=product_media_kit&amp;utm_medium=dom_cleanup&amp;utm_campaign=round_green_brunch_support_20260610';
  const landscapeCartRoute='/products/landscape-tall-coffee-tea-mug?variant=47076796236074&amp;utm_source=product_media_kit&amp;utm_medium=dom_cleanup&amp;utm_campaign=round_green_brunch_support_20260610';
  const openShelvesGuide='/blogs/news/best-ceramic-mug-for-open-kitchen-shelves-round-tall-pleated?utm_source=product_media_kit&amp;utm_medium=dom_cleanup&amp;utm_campaign=round_green_brunch_support_20260610';
  if(window[marker]) return;
  window[marker]=true;
  if(targetPaths.indexOf(window.location.pathname)===-1) return;

  function rewriteLegacyAnchors(root){
    if(!root) return;
    root.querySelectorAll('a[href]').forEach((link)=>{
      const rawHref=link.getAttribute('href') || '';
      const href=rawHref.replace(/&amp;/g,'&');
      if(href.indexOf('/pages/coffeifymug-product-media-kit')===-1 && href.indexOf('/pages/museum-shop-mug-sample-set')===-1) return;
      link.setAttribute('href', shopShareRoute);
      const text=(link.textContent || '').trim();
      if(!text || /product media kit|museum shop mug sample set|buyer sample set/i.test(text)){
        link.textContent='open Shop or Share Fast';
      }
      link.setAttribute('data-growth-bridge', bridgeMarker);
    });
  }

  function replaceParagraph(prefix, html){
    const main=document.getElementById('main') || document.body;
    const paragraphs=Array.from(main.querySelectorAll('p'));
    const target=paragraphs.find((p)=>((p.innerText||p.textContent||'').trim()).startsWith(prefix));
    if(!target) return;
    target.innerHTML=html;
    target.setAttribute('data-growth-bridge', bridgeMarker);
  }

  function rewritePrimaryBlock(){
    replaceParagraph(
      'Primary route for most visitors:',
      '<strong>Best first route for brunch or hosting stories:</strong> <a href="'+roundGreenCartRoute+'">View the Round Mug in Green</a> for the safest everyday first pick with a clearer shelf-to-table color story.'
    );
    replaceParagraph(
      'Need more shelf presence?',
      '<strong>Best supporting option:</strong> <a href="'+pleatedCartRoute+'">View the Pleated Cup at $23.90</a> if you want one calmer secondary mug or cup in the same handoff.'
    );
    replaceParagraph(
      'Need the lower first-order price?',
      '<strong>Need more height on open shelves or breakfast bars?</strong> <a href="'+landscapeCartRoute+'">View the Landscape Tall Mug</a>.'
    );
    replaceParagraph(
      'Before you leave this page:',
      '<strong>Before you leave this page:</strong> pick one next step now: <a href="'+roundGreenCartRoute+'">view the Round Green Mug</a>, <a href="'+pleatedCartRoute+'">view the Pleated Cup as the supporting option</a>, <a href="'+landscapeCartRoute+'">view the Landscape Tall Mug</a>, or <a href="'+assetPacketRoute+'">open the asset packet</a>.'
    );
    replaceParagraph(
      'Need the storage and display angle?',
      '<strong>Need the open-shelf angle?</strong> <a href="'+openShelvesGuide+'">Open Best Ceramic Mug for Open Kitchen Shelves</a> for Round vs. Pleated vs. Tall guidance, or <a href="'+openShelvesGuide+'">stay on the shelf-to-table route</a> if the next step is still a styling decision.'
    );
  }

  function rewriteCards(main){
    if(!main) return;
    main.querySelectorAll('a[href*="/products/round-coffee-tea-mug"]').forEach((link)=>{
      link.setAttribute('href', roundGreenProductRoute);
      link.setAttribute('data-growth-bridge', bridgeMarker);
    });
    main.querySelectorAll('a[href*="/products/round-coffee-tea-mug?variant=47076797415722"]').forEach((link)=>{
      const text=(link.textContent||'').trim();
      if(/add round mug/i.test(text)){
        link.textContent='Add Round Green Mug';
      }else if(/start with the round mug/i.test(text)){
        link.textContent='Start with the Round Mug in Green';
      }
      link.setAttribute('href', roundGreenCartRoute);
      link.setAttribute('data-growth-bridge', bridgeMarker);
    });
    main.querySelectorAll('h3').forEach((heading)=>{
      const text=(heading.textContent||'').trim();
      if(text==='Round Mug'){
        heading.textContent='Round Mug in Green';
        heading.setAttribute('data-growth-bridge', bridgeMarker);
      }
    });
    main.querySelectorAll('figcaption,strong,span,p').forEach((node)=>{
      const text=(node.textContent||'').trim();
      if(text==='Round Ceramic Coffee Mug'){
        node.textContent='Round Ceramic Coffee Mug in Green';
        node.setAttribute('data-growth-bridge', bridgeMarker);
      }
    });
  }

  function cleanup(){
    const main=document.getElementById('main') || document.body;
    if(!main) return;

    const removeNode=(node)=>{
      if(!node) return;
      if(node.id==='coffeifymug-media-kit-visual-strip') return;
      node.remove();
    };

    main.querySelectorAll('a[href*="/products/landscape-tall-coffee-tea-mug?variant=47076796236074"]').forEach((link)=>{
      const text=(link.textContent||'').trim();
      if(text==='Add Tall Mug'){
        link.textContent='Add Landscape Tall';
      }
    });

    const heading=main.querySelector('h1');
    if(heading){
      heading.textContent='CoffeifyMug Shop or Share Fast';
      heading.setAttribute('data-growth-bridge', bridgeMarker);
    }
    if(typeof document.title === 'string' && /Product Media Kit/i.test(document.title)){
      document.title=document.title.replace(/Product Media Kit/gi,'Shop or Share Fast');
    }

    main.querySelectorAll('p').forEach((p)=>{
      const text=(p.innerText||p.textContent||'').trim();
      if(
        text.startsWith('Quick answer:') ||
        text.startsWith('Use this media kit to shop, share, or review CoffeifyMug faster:')
      ){
        p.style.display='none';
        p.setAttribute('data-growth-bridge', bridgeMarker);
      }
    });

    main.querySelectorAll('a[href*="/pages/museum-shop-mug-sample-set"]').forEach((link)=>{
      const block = link.closest('div[style*="border"]') || link.closest('li') || link.closest('p');
      removeNode(block);
    });

    Array.from(main.querySelectorAll('div,ul')).forEach((node)=>{
      const text=(node.innerText||node.textContent||'').trim();
      if(!text) return;
      if(
        text.includes('2-Mug Starter Set') ||
        text.includes('3-Piece Starter Set') ||
        text.includes('Open the Museum Shop Mug Sample Set') ||
        text.includes('Buyer Sample Set')
      ){
        const block = node.closest('div[style*="border"]') || node;
        removeNode(block);
      }
    });

    const supportLinks=Array.from(main.querySelectorAll('a[href*="/pages/coffeifymug-editor-buyer-asset-packet"]'));
    supportLinks.forEach((link)=>{
      const block = link.closest('div[style*="border"]');
      if(block){
        const text=(block.innerText||block.textContent||'').trim();
        if(text.includes('Open the Museum Shop Mug Sample Set')){
          removeNode(block);
        }
      }
    });

    rewriteLegacyAnchors(main);
    rewritePrimaryBlock();
    rewriteCards(main);
  }

  function installSupportNote(){
    const main=document.getElementById('main') || document.body;
    if(!main) return;
    let existing=document.getElementById('coffeifymug-media-kit-dom-cleanup-note');
    const html=[
      '<div style="margin:0 0 14px;padding:14px 16px;border:1px solid #d8e4df;border-radius:10px;background:#f7fbf9;line-height:1.45;">',
      '<p style="margin:0 0 6px;font-size:12px;letter-spacing:0.08em;text-transform:uppercase;color:#7b6546;">Brunch and shelf-to-table route</p>',
      '<h2 style="margin:0 0 8px;font-size:24px;line-height:1.18;color:#1d2b24;">Start with Round Mug in Green, then add Pleated only if you need a supporting cup.</h2>',
      '<p style="margin:0 0 10px;">For breakfast hosting, brunch tables, and editor handoffs, this is the clearest two-piece direction using real CoffeifyMug product visuals already live on the store.</p>',
      '<div style="display:flex;flex-wrap:wrap;gap:8px;margin:0 0 10px;">',
      '<a style="display:inline-block;padding:10px 12px;border-radius:999px;background:#1f6b57;color:#ffffff;text-decoration:none;font-weight:700;" href="'+roundGreenCartRoute+'">View Round Green Mug</a>',
      '<a style="display:inline-block;padding:10px 12px;border-radius:999px;border:1px solid #d8c29d;background:#fff7e8;color:#7b6546;text-decoration:none;font-weight:700;" href="'+pleatedCartRoute+'">View Pleated Cup</a>',
      '<a style="display:inline-block;padding:10px 12px;border-radius:999px;border:1px solid #c7d9d2;background:#ffffff;color:#1f6b57;text-decoration:none;font-weight:600;" href="'+shopShareRoute+'">Stay on Shop or Share Fast</a>',
      '</div>',
      '<p style="margin:0;"><strong>Need one-page handoff?</strong> <a href="'+assetPacketRoute+'">Open the Editor &amp; Buyer Asset Packet</a>. <strong>Need the open-shelf angle?</strong> <a href="'+openShelvesGuide+'">Open Best Ceramic Mug for Open Kitchen Shelves</a>.</p>',
      '</div>'
    ].join('');
    if(existing){
      existing.setAttribute('data-growth-bridge', bridgeMarker);
      existing.innerHTML=html;
      return;
    }
    const anchor=main.querySelector('#coffeifymug-media-kit-visual-strip') || main.firstElementChild;
    existing=document.createElement('section');
    existing.id='coffeifymug-media-kit-dom-cleanup-note';
    existing.setAttribute('data-growth-bridge', bridgeMarker);
    existing.innerHTML=html;
    if(anchor && anchor.parentNode===main){
      anchor.insertAdjacentElement('afterend', existing);
    }else{
      main.insertBefore(existing, main.firstChild);
    }
  }

  function apply(){
    cleanup();
    installSupportNote();
  }

  function observe(){
    if(window.__coffeifymugMediaKitDomCleanupObserver) return;
    const root=document.getElementById('main') || document.body;
    if(!root || !window.MutationObserver) return;
    const observer=new MutationObserver(()=>apply());
    observer.observe(root,{childList:true,subtree:true});
    window.__coffeifymugMediaKitDomCleanupObserver=observer;
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', ()=>{apply();observe();}, {once:true});
  }else{
    apply();
    observe();
  }
  window.addEventListener('load', ()=>{apply();observe();}, {once:true});
  setTimeout(apply, 250);
  setTimeout(apply, 1500);
  setTimeout(apply, 4000);
  setTimeout(apply, 8000);
})();
;(()=>{
  const marker='gallery_fast_cart_asset_redirect_20260610';
  const bridgeMarker='gallery_fast_cart_asset_redirect_20260610_v1';
  const sourcePath='/pages/coffeifymug-product-image-gallery';
  const targetPath='/pages/coffeifymug-product-image-gallery-fast-cart';
  if(window[marker]) return;
  window[marker]=true;
  if(window.location.pathname!==sourcePath) return;

  const params=new URLSearchParams(window.location.search || '');
  if(params.get('stay_on_gallery')==='1' || params.get('preview_gallery')==='1') return;

  if(!params.has('utm_source')) params.set('utm_source','product_image_gallery');
  if(!params.has('utm_medium')) params.set('utm_medium','stale_handle_redirect');
  if(!params.has('utm_campaign')) params.set('utm_campaign','gallery_fast_cart_redirect_20260610');
  params.set('redirected_from','product_image_gallery_asset_cache');

  const target=targetPath+'?'+params.toString();
  if(window.location.pathname + window.location.search === target) return;
  window.location.replace(target);
  document.documentElement.setAttribute('data-growth-bridge', bridgeMarker);
})();
;(()=>{
  const marker='gallery_conversion_focus_asset_cleanup_20260610_pleated_first';
  const bridgeMarker='gallery_conversion_focus_bridge_20260610_asset_pleated_first';
  const shopShareRoute='/pages/coffeifymug-shop-share-fast?utm_source=product_image_gallery&amp;utm_medium=hero_route&amp;utm_campaign=gallery_pleated_first_20260610';
  if(window[marker]) return;
  window[marker]=true;
  if(window.location.pathname!=='/pages/coffeifymug-product-image-gallery') return;

  const bridgeHtml=[
    '<div style="border:1px solid #d8c29d;border-radius:10px;padding:16px 16px 14px;margin:0 auto 18px;max-width:1080px;background:#fffdf8;line-height:1.45;box-shadow:0 8px 22px rgba(29,43,36,0.06);">',
    '<p style="margin:0 0 6px;font-size:12px;letter-spacing:0.08em;text-transform:uppercase;color:#7b6546;">Lowest-friction first order</p>',
    '<h2 style="margin:0 0 8px;font-size:28px;line-height:1.15;color:#1d2b24;">Start with the easiest yes, not the highest first spend.</h2>',
    '<p style="margin:0 0 12px;color:#4b4f4c;">If this is your first CoffeifyMug order and you want the easiest first step, start with the Pleated Cup at $23.90. Use the Round Mug if you want the broadest everyday default. Open Shop or Share Fast only when this visit is for buyer review, editorial handoff, or museum-shop context.</p>',
    '<div style="display:flex;flex-wrap:wrap;gap:8px;">',
    '<a style="display:inline-block;padding:10px 12px;border:1px solid #1f6b57;border-radius:999px;text-decoration:none;color:#ffffff;font-weight:700;background:#1f6b57;" href="/products/pleated-coffee-tea-cup?variant=47076746690858&amp;utm_source=product_image_gallery&amp;utm_medium=hero_route&amp;utm_campaign=gallery_pleated_first_20260610">View Pleated $23.90</a>',
    '<a style="display:inline-block;padding:10px 12px;border:1px solid #d8c29d;border-radius:999px;text-decoration:none;color:#7b6546;font-weight:600;background:#fff7e8;" href="/products/round-coffee-tea-mug?variant=47076797415722&amp;utm_source=product_image_gallery&amp;utm_medium=hero_route&amp;utm_campaign=gallery_pleated_first_20260610">View Round Mug</a>',
    '<a style="display:inline-block;padding:10px 12px;border:1px solid #c7d9d2;border-radius:999px;text-decoration:none;color:#1f6b57;font-weight:600;background:#ffffff;" href="'+shopShareRoute+'">Open Shop or Share Fast</a>',
    '</div>',
    '</div>',
    '<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(220px,1fr));gap:18px;margin:0 auto 18px;max-width:1080px;align-items:start;">',
    '<figure style="margin:0;display:flex;flex-direction:column;border:1px solid #eadbc2;border-radius:10px;overflow:hidden;background:#ffffff;">',
    '<a href="/products/pleated-coffee-tea-cup?utm_source=product_image_gallery&amp;utm_medium=image_card&amp;utm_campaign=gallery_pleated_first_20260610"><img src="https://cdn.shopify.com/s/files/1/0830/9394/6666/files/03-pleated-coffee-tea-cup_f047a0f1-c34b-4e89-9e67-13f5741f2800.png?v=1780238271" alt="Pleated Elegant Ceramic Coffee Cup from CoffeifyMug" loading="eager" style="width:100%;height:230px;object-fit:cover;display:block;"></a>',
    '<figcaption style="padding:12px 12px 14px;display:flex;flex:1;flex-direction:column;gap:8px;"><strong style="font-size:18px;color:#1d2b24;">Pleated Elegant Ceramic Coffee Cup</strong><span style="color:#4b4f4c;">Best lower-price first order when the blocker is commitment, not style.</span><a style="display:block;padding:10px 12px;border-radius:8px;background:#1f6b57;color:#ffffff;text-decoration:none;font-weight:700;text-align:center;" href="/products/pleated-coffee-tea-cup?variant=47076746690858&amp;utm_source=product_image_gallery&amp;utm_medium=image_card&amp;utm_campaign=gallery_pleated_first_20260610">View Pleated $23.90</a><a style="display:block;padding:10px 12px;border-radius:8px;background:#f7f2ea;color:#1f6b57;text-decoration:none;font-weight:600;text-align:center;border:1px solid #d8c29d;" href="/products/pleated-coffee-tea-cup?utm_source=product_image_gallery&amp;utm_medium=image_card&amp;utm_campaign=gallery_pleated_first_20260610">Open product page</a></figcaption>',
    '</figure>',
    '<figure style="margin:0;display:flex;flex-direction:column;border:1px solid #eadbc2;border-radius:10px;overflow:hidden;background:#ffffff;">',
    '<a href="/products/round-coffee-tea-mug?utm_source=product_image_gallery&amp;utm_medium=image_card&amp;utm_campaign=gallery_pleated_first_20260610"><img src="https://cdn.shopify.com/s/files/1/0830/9394/6666/files/02-round-coffee-tea-mug_62146bf8-a988-42cd-8336-9fd4411bd965.png?v=1780238262" alt="Round Ceramic Coffee Mug from CoffeifyMug" loading="eager" style="width:100%;height:230px;object-fit:cover;display:block;"></a>',
    '<figcaption style="padding:12px 12px 14px;display:flex;flex:1;flex-direction:column;gap:8px;"><strong style="font-size:18px;color:#1d2b24;">Round Ceramic Coffee Mug</strong><span style="color:#4b4f4c;">Best broad everyday default when you want the safest all-around mug first.</span><a style="display:block;padding:10px 12px;border-radius:8px;background:#1f6b57;color:#ffffff;text-decoration:none;font-weight:700;text-align:center;" href="/products/round-coffee-tea-mug?variant=47076797415722&amp;utm_source=product_image_gallery&amp;utm_medium=image_card&amp;utm_campaign=gallery_pleated_first_20260610">View Round Mug</a><a style="display:block;padding:10px 12px;border-radius:8px;background:#f7f2ea;color:#1f6b57;text-decoration:none;font-weight:600;text-align:center;border:1px solid #d8c29d;" href="/products/round-coffee-tea-mug?utm_source=product_image_gallery&amp;utm_medium=image_card&amp;utm_campaign=gallery_pleated_first_20260610">Open product page</a></figcaption>',
    '</figure>',
    '<figure style="margin:0;display:flex;flex-direction:column;border:1px solid #eadbc2;border-radius:10px;overflow:hidden;background:#ffffff;">',
    '<a href="/products/landscape-tall-coffee-tea-mug?utm_source=product_image_gallery&amp;utm_medium=image_card&amp;utm_campaign=gallery_pleated_first_20260610"><img src="https://cdn.shopify.com/s/files/1/0830/9394/6666/files/01-landscape-tall-coffee-tea-mug_9c0bc318-cc47-4af5-b2b2-2654b4eae064.png?v=1780238254" alt="Landscape Tall Coffee and Tea Mug from CoffeifyMug" loading="eager" style="width:100%;height:230px;object-fit:cover;display:block;"></a>',
    '<figcaption style="padding:12px 12px 14px;display:flex;flex:1;flex-direction:column;gap:8px;"><strong style="font-size:18px;color:#1d2b24;">Landscape Tall Coffee &amp; Tea Mug</strong><span style="color:#4b4f4c;">Use this when visual presence and a taller silhouette matter more than the simplest first order.</span><a style="display:block;padding:10px 12px;border-radius:8px;background:#1f6b57;color:#ffffff;text-decoration:none;font-weight:700;text-align:center;" href="/products/landscape-tall-coffee-tea-mug?variant=47076796236074&amp;utm_source=product_image_gallery&amp;utm_medium=image_card&amp;utm_campaign=gallery_pleated_first_20260610">View Landscape Tall</a><a style="display:block;padding:10px 12px;border-radius:8px;background:#f7f2ea;color:#1f6b57;text-decoration:none;font-weight:600;text-align:center;border:1px solid #d8c29d;" href="/products/landscape-tall-coffee-tea-mug?utm_source=product_image_gallery&amp;utm_medium=image_card&amp;utm_campaign=gallery_pleated_first_20260610">Open product page</a></figcaption>',
    '</figure>',
    '</div>'
  ].join('');

  function rewriteLegacyAnchors(root){
    if(!root) return;
    root.querySelectorAll('a[href]').forEach((link)=>{
      const rawHref=link.getAttribute('href') || '';
      const href=rawHref.replace(/&amp;/g,'&');
      const text=(link.textContent || '').trim();
      const buyerRoute=href.indexOf('/pages/coffeifymug-product-media-kit')!==-1 || href.indexOf('/pages/museum-shop-mug-sample-set')!==-1;
      const compareLoop=href.indexOf('/pages/coffeifymug-product-image-gallery')!==-1 || href.indexOf('/pages/coffee-mug-photo-picker')!==-1;
      if(buyerRoute){
        link.setAttribute('href', shopShareRoute);
        if(!text || /product media kit|buyer sample set|museum shop mug sample set/i.test(text)){
          link.textContent='Shop or Share Fast';
        }
        link.setAttribute('data-growth-bridge', bridgeMarker);
        return;
      }
      if(compareLoop){
        link.setAttribute('href', shopShareRoute);
        if(!text || /photo picker|image gallery|product image gallery/i.test(text)){
          link.textContent='Shop or Share Fast';
        }
        link.setAttribute('data-growth-bridge', bridgeMarker);
      }
    });
  }

  function removeOldDomBridge(){
    const old=document.getElementById('coffeifymug-gallery-photo-picker-dom-bridge');
    if(old) old.remove();
    document.querySelectorAll('[data-growth-bridge="gallery_photo_picker_dom_bridge_20260606"]').forEach((node)=>node.remove());
  }

  function hideRedundantIntroCopy(){
    const main=document.getElementById('main');
    if(!main) return;
    const removeBlockForText=(text)=>{
      const block=text.closest('div[style*="border:1px solid"]') || text.parentElement;
      if(block && block !== main){
        block.remove();
      }else if(text){
        text.style.display='none';
        text.setAttribute('data-growth-bridge', bridgeMarker);
      }
    };
    const paragraphs=main.querySelectorAll('p');
    paragraphs.forEach((p)=>{
      const text=(p.textContent||'').trim();
      if(
        text.startsWith('Quick answer for first-time orders:') ||
        text.startsWith('Compare first: open Pick a Mug Fast') ||
        text.startsWith('Quick answer: if you came here to compare real CoffeifyMug product photos,') ||
        text.startsWith('Lowest-commitment first order:') ||
        text.startsWith('Safest everyday default:') ||
        text.startsWith('Shortest route:') ||
        text.startsWith('Buyer or review route:') ||
        text.startsWith('Ready now:') ||
        text.startsWith('Do not leave in compare mode:') ||
        text.startsWith('Still need support instead of more comparison?') ||
        text.startsWith('Need a buyer, gift-guide, or editor handoff instead of another compare step?') ||
        text.startsWith('Start with one mug, not another compare loop.')
      ){
        removeBlockForText(p);
      }
    });
    const lists=main.querySelectorAll('li');
    lists.forEach((li)=>{
      const text=(li.textContent||'').trim();
      if(
        text.startsWith('Pick a Mug Fast for the shortest decision path.') ||
        text.startsWith('Museum Shop Mug Sample Set if this visit is for buyer review, museum retail, or a gift-guide handoff.') ||
        text.startsWith('Product Media Kit for editor, reviewer, and buyer context.')
      ){
        const list=li.closest('ul');
        if(list){
          list.remove();
        }
      }
    });
  }

  function upgradeBridge(){
    const main=document.getElementById('main');
    if(!main) return;
    let existing=document.getElementById('coffeifymug-gallery-cache-bridge');
    if(!existing){
      existing=document.createElement('section');
      existing.id='coffeifymug-gallery-cache-bridge';
      main.insertBefore(existing, main.firstChild);
    }
    existing.setAttribute('data-growth-bridge', bridgeMarker);
    existing.innerHTML=bridgeHtml;
  }

  function apply(){
    removeOldDomBridge();
    upgradeBridge();
    hideRedundantIntroCopy();
    rewriteLegacyAnchors(document.getElementById('main') || document.body);
  }

  function observe(){
    if(window.__coffeifymugGalleryConversionFocusObserver) return;
    const root=document.getElementById('main') || document.body;
    if(!root || !window.MutationObserver) return;
    const observer=new MutationObserver(()=>apply());
    observer.observe(root,{childList:true,subtree:true});
    window.__coffeifymugGalleryConversionFocusObserver=observer;
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', ()=>{apply();observe();}, {once:true});
  }else{
    apply();
    observe();
  }
  window.addEventListener('load', ()=>{apply();observe();}, {once:true});
  setTimeout(apply, 250);
  setTimeout(apply, 1500);
  setTimeout(apply, 4000);
  setTimeout(apply, 8000);
})();
